import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute } from '@angular/router';
import { blobToBase64String, base64StringToBlob } from 'blob-util';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { FormControl } from '@angular/forms';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-avt-ressources-pedagogique',
  templateUrl: './avt-ressources-pedagogique.component.html',
  styleUrls: ['./avt-ressources-pedagogique.component.scss'],
})
export class AvtRessourcesPedagogiqueComponent implements OnInit {
  constructor(
    public generalService: GeneralService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public overlay: Overlay,
    public viewContainerRefCalmoi: ViewContainerRef
  ) {
    this.listeRessources = new MatTableDataSource();
  }
  fenetre: string;
  listeRessources;
  listeRessourcesBrute;
  clickMode: string;
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Text',
        Lg_Code: '',
        TableRD_Des: 'Désignations',
        TableRD_Largeur: 400,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Key',
        Lg_Code: '',
        TableRD_Des: 'Collaborateur',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Class',
        Lg_Code: '',
        TableRD_Des: 'Taille',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        numColonneToShow: 1,
        numColonneToReturn: 0,
        recherche: 'ecarticleauto',
        param: '',
        required: true,
        style: { width: '400px' },
        placeholder: 'Article',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Dll',
        Lg_Code: '',
        TableRD_Des: 'Type',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Extension',
        Lg_Code: '',
        TableRD_Des: 'Format',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Date',
        Lg_Code: '',
        TableRD_Des: 'Création',
        TableRD_Largeur: 90,
        TableRD_ReadOnly: false,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  rows = [];
  initDoc;
  exist: boolean = true;
  columnsName = [];
  nomFenetre: string;
  nameFolder: string;
  compteur = 0;
  overlayRef: OverlayRef | null;
  @ViewChild('menuContectuelle', { static: true })
  menuContectuelle: TemplateRef<any>;
  subAction: Subscription;
  fileToDelete = [];
  textAlign = ['left', 'center', 'right'];
  toppings = new FormControl();
  listeCollaborateurs = [];
  listeSelectedCollaborateurs = [];
  ngOnInit() {
    this.setColumnsName();
    this.readParamUrl();
  }
  getListeCollaborateurs() {
    this.generalService
      .rechercheTable(globalUrls.urlListPerso + '0')
      .subscribe((data) => {
        this.listeCollaborateurs = this.generalService.sort(data, 'Perso_Nom');
        this.init();
      });
  }

  filterListeRessourcesByCollaborateur(
    openAllNode: boolean,
    setOnKeyUp: boolean
  ) {
    if (this.fenetre == 'ressources') {
      if (openAllNode) this.openAllNode();
      if (setOnKeyUp) this.onkeyup(false, false);
      if (this.listeSelectedCollaborateurs.length > 0) {
        var listePerso_Matricule = ';';
        this.listeSelectedCollaborateurs.forEach((col) => {
          listePerso_Matricule += col + ';';
        });
        this.listeRessources.data.forEach((ressource) => {
          if (
            listePerso_Matricule.indexOf(';' + ressource.File_Key + ';') == -1
          )
            ressource['class'] = 'hideRow';
        });
      }
    }
  }
  setColumnsName() {
    this.columnsName = this.columns.TableRD.map((col) => col.TableRD_Champs);
  }
  getChild(listeRessources, File_Id) {
    return listeRessources.filter((ressource) => {
      return ressource.File_Parent == File_Id;
    });
  }
  rermouveChild(tree) {
    tree.forEach((t) => {
      var child = this.getChild(this.listeRessources, t.File_Id);
      t['class'] = 'hideRow';
      if (child.length > 0) {
        this.rermouveChild(child);
      }
    });
  }
  setFileToDelete(tree) {
    tree.forEach((t) => {
      var child = this.getChild(this.listeRessources.data, t.File_Id);
      this.fileToDelete.push(t);
      if (child.length > 0) {
        this.setFileToDelete(child);
      }
    });
  }
  addChild(tree) {
    tree.forEach((t) => {
      var child = this.getChild(this.listeRessources, t.File_Id);
      t['class'] = '';
      if (t['icon'] != '') t['icon'] = 'remove';
      if (child.length > 0) {
        this.addChild(child);
      }
    });
  }
  bouclerTree(tree, margin) {
    tree.forEach((t) => {
      t['compteur'] = this.generalService.clone(this.compteur);
      this.compteur++;
      t['margin'] = margin + 30;
      var child = this.getChild(this.listeRessources, t.File_Id);

      if (child.length > 0) {
        t['icon'] = 'remove';
        this.bouclerTree(child, t['margin']);
      } else t['icon'] = '';
    });
  }
  getListeParentRessources(listeRessources) {
    return listeRessources.filter((ressource) => {
      return ressource.File_Parent == '' || ressource.File_Parent == null;
    });
  }
  setMarginlisteRessources() {
    var listeParentRessources = this.getListeParentRessources(
      this.listeRessources
    );

    this.bouclerTree(listeParentRessources, -30);
  }
  getListeFile(url) {
    this.rows = [];
    this.generalService.rechercheTable(url).subscribe((listeRessources) => {
      this.listeRessources = listeRessources;
      //this.listeRessourcesBrute =  new MatTableDataSource (this.generalService.clone(listeRessources));

      this.listeRessources.forEach((element) => {
        element['class'] = '';
        if (element.File_Dll == 'jstree-folder') element.File_Dll = 'Dossier';
        else element.File_Dll = 'Fichier';
        var col = this.listeCollaborateurs.find((col) => {
          return col.Perso_Matricule == element.File_Key;
        });
        if (col) col = col.Perso_Nom + ' ' + col.Perso_Prenom;
        else col = '';
        element.File_Key = col;
      });
      this.setMarginlisteRessources();
      this.listeRessources.sort(function (a, b) {
        return a.compteur - b.compteur;
      });
      this.listeRessources = new MatTableDataSource(this.listeRessources);
      this.listeRessources.filterPredicate = this.createFilter();
    });
  }
  toggleRow(row) {
    if (this.generalService.isNotEmpty(row['icon'])) {
      this.listeRessources = this.listeRessources.data;
      if (row['icon'] == 'remove') {
        row['icon'] = 'add';
        var child = this.getChild(this.listeRessources, row.File_Id);
        this.rermouveChild(child);
      } else {
        row['icon'] = 'remove';
        var child = this.getChild(this.listeRessources, row.File_Id);
        this.addChild(child);
        this.listeRessources.sort(function (a, b) {
          return a.compteur - b.compteur;
        });
      }
      this.listeRessources = new MatTableDataSource(this.listeRessources);
      this.filterListeRessourcesByCollaborateur(false, false);
      this.listeRessources.filterPredicate = this.createFilter();
      this.onkeyup(false, false);
    }
  }
  openAllNode() {
    this.listeRessources.data.forEach((row) => {
      if (row['icon'] == 'add') row['icon'] = 'remove';
      row['class'] = '';
    });
  }
  getUrl() {
    var url;
    //tout les ressources
    if (this.fenetre == 'ressources') {
      url = globalUrls.urlListeFilesR2 + 'ressource,collaborateur';
    }
    //mes ressource
    if (this.fenetre == 'ressource') {
      url =
        globalUrls.urlListeFilesR +
        this.generalService.collaborateurConnecter +
        ',ressource,collaborateur';
    }
    return url;
  }
  clickRow(event, row) {
    // var els = document.getElementsByClassName("rowClass");
    // Array.prototype.forEach.call(els, function(el)
    // {
    //   el.style="";
    // });
    // event.currentTarget.style="background-color: rgb(160, 189, 243);";
    // this.rows = row;

    if (event.currentTarget.style.backgroundColor == 'rgb(160, 189, 243)') {
      event.currentTarget.style.backgroundColor = '';
      this.rows = this.rows.filter((r) => {
        return r.File_Id != row.File_Id;
      });
    } else {
      event.currentTarget.style.backgroundColor = 'rgb(160, 189, 243)';
      this.rows.push(row);
    }
  }
  onChangeFileToUpload(fileInput) {
    blobToBase64String(fileInput.target.files[0]).then((base64String) => {
      var parent = '';
      var File_Key = this.generalService.collaborateurConnecter;
      if (this.rows.length == 1) {
        parent = this.rows[0].File_Id;
      } else if (this.rows.length > 1) {
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une seule ligne',
          false
        );
        return;
      }
      var File_Extension = fileInput.target.files[0].name.substring(
        fileInput.target.files[0].name.indexOf('.'),
        fileInput.target.files[0].name.length
      );
      this.addFiles(
        base64String,
        fileInput.target.files[0].name,
        File_Key,
        parent,
        File_Extension,
        fileInput.target.files[0].size
      );
    });
  }
  addFiles(
    File_Content,
    File_Text,
    File_Key,
    File_Parent,
    File_Extension,
    File_Class
  ) {
    var initDoc = this.generalService.initDoc;
    initDoc.files[0].File_Parent = File_Parent;
    initDoc.files[0].File_Content = File_Content;
    initDoc.files[0].File_Text = File_Text;
    initDoc.files[0].File_Key = File_Key;

    initDoc.files[0].File_Extension = File_Extension;
    initDoc.files[0].File_Type = 'collaborateur';
    initDoc.files[0].File_Groupe = 'ressource';
    if (this.clickMode == 'crerFichier') {
      //File_Class : taille de fichier
      if (File_Class / 1000000 >= 1)
        File_Class = (File_Class / 1000000).toFixed(3) + ' Mo';
      else if (File_Class / 1000 >= 1)
        File_Class = (File_Class / 1000).toFixed(3) + ' ko';
      else File_Class += ' octet';
      initDoc.files[0].File_Dll = 'jstree-file';
      initDoc.files[0].File_Class = File_Class;
    }
    if (this.clickMode == 'crerDossier') {
      initDoc.files[0].File_Dll = 'jstree-folder';
    }
    this.enregistrerFile(initDoc);
  }
  enregistrerFile(initDoc) {
    this.exist = false;
    this.generalService.enregisterTable(initDoc).subscribe(
      (data) => {
        this.exist = true;
        this.generalService.dialogSuccess('Enregistré', true);
        this.init();
      },
      () => {
        this.exist = true;
        this.generalService.dialogSuccess('Non enregistré', false);
      }
    );
  }
  renommerFichierDossier(frmAddFolder) {
    if (this.rows.length == 1) {
      this.generalService
        .rechercheTable(globalUrls.urlFiles + '&val=' + this.rows[0].File_Id)
        .subscribe((file) => {
          this.initDoc = file;
          this.clickMode = 'renommer';
          this.nameFolder = file.Files[0].File_Text;
          this.dialog.open(frmAddFolder, new MatDialogConfig());
        });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
  async telechargerFicher() {
    if (this.rows.length == 1) {
      const contentType = 'application/pdf';
      const b64Data = await this.generalService
        .rechercheTable(globalUrls.urlFiles + '&val=' + this.rows[0].File_Id)
        .toPromise();
      const blob = base64StringToBlob(
        b64Data.Files[0].File_Content,
        contentType
      );
      var fileURL = URL.createObjectURL(blob);
      window.URL.revokeObjectURL(fileURL);
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, this.rows[0].File_Text);
        return;
      }
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', this.rows[0].File_Text);
      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      // For Firefox it is necessary to delay revoking the ObjectURL
      setTimeout(() => {
        window.URL.revokeObjectURL(blobURL);
      }, 100);
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
  }
  supprimerFicher() {
    if (this.rows.length > 0) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.fileToDelete = [];
          this.rows.forEach((row) => {
            this.setFileToDelete(
              this.listeRessources.data.filter((r) => {
                return r.File_Id == row.File_Id;
              })
            );
          });

          this.fileToDelete.forEach((file) => {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(
              file.File_Id,
              'avtFiles'
            );
            if (deleteFn != null) {
              this.exist = false;
              deleteFn.subscribe(
                (data) => {
                  console.log(file.File_Id);
                  this.init();
                  this.generalService.dialogSuccess('Elément supprimer', true);
                  this.exist = true;
                },
                (error) => {
                  this.generalService.dialogSuccess(
                    'Elément non supprimé',
                    false
                  );
                  this.exist = true;
                }
              );
            }
          });
        }
        if (result == 'annuler') {
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  ajouterFicher() {
    if (this.generalService.isNotEmpty(this.generalService.initDoc)) {
      this.quiterMenuContectuelle();
      this.clickMode = 'crerFichier';
      document.getElementById('fileToUpload').click();
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  ajouterDossier(frmAddFolder) {
    if (this.rows.length > 1) {
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
      return;
    }
    if (this.generalService.isNotEmpty(this.generalService.initDoc)) {
      this.clickMode = 'crerDossier';
      this.dialog.open(frmAddFolder, new MatDialogConfig());
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  closeFrmAddFolder(action) {
    if (action == 'annuler') {
      this.dialog.closeAll();
    }
    if (action == 'ok') {
      if (this.generalService.isNotEmpty(this.nameFolder)) {
        this.exist = false;
        this.dialog.closeAll();

        if (this.clickMode == 'renommer') {
          this.renommer();
        }
        if (this.clickMode == 'crerDossier') {
          this.crerDossier();
        }
      }
    }
  }
  renommer() {
    this.initDoc.Files[0].File_Text = this.nameFolder;
    this.enregistrerFile(this.initDoc);
  }
  crerDossier() {
    var File_Key = this.generalService.collaborateurConnecter;
    var File_Id = '';
    if (this.rows.length == 1) {
      File_Id = this.rows[0].File_Id;
    } else if (this.rows.length > 1) {
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une seule ligne',
        false
      );
      return;
    }
    this.addFiles('', this.nameFolder, File_Key, File_Id, '', '');
  }
  setNomFenetre() {
    //tout les ressources
    if (this.fenetre == 'ressources') {
      this.nomFenetre = 'RESSOURCES ÉQUIPE';
    }
    //mes ressources
    if (this.fenetre == 'ressource') {
      this.nomFenetre = 'MES RESSOURCES';
    }
  }
  init() {
    if (
      this.generalService.isNotEmpty(this.generalService.collaborateurConnecter)
    ) {
      var url = this.getUrl();
      this.getListeFile(url);
    } else
      setTimeout(() => {
        this.init();
      }, 100);
  }
  openMenuContectuelle(event: MouseEvent, row) {
    if (this.fenetre == 'ressource') {
      this.clickRow(event, row);
      event.preventDefault();
      this.quiterMenuContectuelle();
      const positionStrategy = this.overlay
        .position()
        .flexibleConnectedTo({ x: event.x, y: event.y - 150 })
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]);
      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.close(),
      });
      this.overlayRef.attach(
        new TemplatePortal(this.menuContectuelle, this.viewContainerRefCalmoi)
      );
    }
  }
  quiterMenuContectuelle() {
    this.subAction && this.subAction.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
  getStyle(column) {
    return {
      width: column.TableRD_Largeur + 'px',
      'text-align': this.textAlign[column.TableRD_Alligement],
    };
  }
  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data, filter) => {
      var test: boolean = true;
      let searchTerms = JSON.parse(filter);
      this.columns.TableRD.forEach((col) => {
        if (
          searchTerms[col['TableRD_Champs']] != undefined &&
          searchTerms[col['TableRD_Champs']] != null &&
          searchTerms[col['TableRD_Champs']] != ''
        )
          test =
            test &&
            data[col['TableRD_Champs']]
              .toString()
              .toLowerCase()
              .indexOf(searchTerms[col['TableRD_Champs']].toLowerCase()) != -1;
      });
      return test;
    };

    return filterFunction;
  }
  onkeyup(
    openAllNode: boolean,
    setFilterListeRessourcesByCollaborateur: boolean
  ) {
    if (openAllNode) this.openAllNode();
    if (setFilterListeRessourcesByCollaborateur)
      this.filterListeRessourcesByCollaborateur(false, false);
    var myJson: any = {};
    const listInput: any = document.getElementsByClassName('inputSearch');
    Array.prototype.forEach.call(listInput, (el) => {
      myJson[el.name] = el.value;
    });
    this.listeRessources.filter = JSON.stringify(myJson);
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.fenetre = params['fenetre'];
      this.setNomFenetre();
      this.getListeCollaborateurs();
    });
  }
}
